export const utils = {
    formatImageUrl: (sourceRoot: { image?: string }, path: string) => {
        if (sourceRoot && sourceRoot.image) {
            return sourceRoot.image + path;
        }
        return path;
    },
    uuid: () => {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    log: (m: string = '', t: any, c = 'red') => {
        console.log(`%c ${m}在这里===>`, `color: ${c};font-size: 24px;`, t);
    },
};
